import React from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { AREA_OF_LAW_CATEGORIES } from '../constants';
import AccordionMultiSelect from '../controls/AccordionMultiSelect';
import NavRow from '../fields/NavRow';
import { TaskDefinition, TaskStepRenderArgs } from '../QuestionnaireShell';
import { AreasOfLawValues } from '../types';
import { zodResolver } from '../validation';

const schema = z.object({
  areasOfLaw: z
    .array(
      z.object({
        category: z.string(),
        choices: z.array(z.string()).min(1),
      }),
    )
    .min(1, 'Please select at least one area of law'),
});

const DEFAULTS: AreasOfLawValues = { areasOfLaw: [] };

const AreasOfLawForm = ({ initialValues, onComplete, onBack, onCancelEdit, submitLabel }: TaskStepRenderArgs) => {
  const defaults = (initialValues as AreasOfLawValues | undefined) ?? DEFAULTS;
  const {
    control,
    handleSubmit,
    formState: { isValid },
  } = useForm<AreasOfLawValues>({
    defaultValues: defaults,
    resolver: zodResolver(schema),
    mode: 'onChange',
  });

  const onSubmit = handleSubmit((values) => onComplete(values));

  return (
    <form className="rnq-form" onSubmit={(e) => e.preventDefault()}>
      <AccordionMultiSelect control={control} name="areasOfLaw" categories={AREA_OF_LAW_CATEGORIES} required />
      <NavRow
        onBack={onBack}
        onCancelEdit={onCancelEdit}
        onSubmit={onSubmit}
        submitLabel={submitLabel}
        disabled={!isValid}
      />
    </form>
  );
};

const AreasOfLaw: TaskDefinition = {
  key: 'task6',
  label: 'Areas',
  title: 'What areas of law do you practice?',
  description: 'Select all that apply.',
  render: (args) => <AreasOfLawForm {...args} />,
};

export default AreasOfLaw;
